// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Adjustments for section spacing */
#home,
#gallery {
  padding-top: 100px; /* Ensure space from the navbar */
  padding-bottom: 100px;
}

#contact {
  padding-top: 130px;
  margin-bottom: 130px;
}

#about {
  padding-top: 100px;
  margin-bottom: 100px;
}
#menu {
  margin-top: 200px;
  margin-bottom: 100px;
  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, .8);
}

#gallery {
  padding: 100px 0;
  margin-bottom: 70px;
}

#gallery h1 {
  color: #8B4513; /* Warm brown color */
  margin-bottom: 20px;
}

.carousel-container {
  max-width: 800px; /* Adjust the max width to your preference */
  margin: 0 auto; /* Center the carousel */
}

.carousel-image {
  height: 400px; /* Adjust the height to your preference */
  object-fit: cover; /* Ensure the image covers the entire area */
}

.carousel-caption {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 5px;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1 1;
}

.background-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.background-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.background-container img.active {
  opacity: 1;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Darken the background images */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;;EAEE,kBAAkB,EAAE,iCAAiC;EACrD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,4CAA4C;EAC9D,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,iBAAiB,EAAE,4CAA4C;AACjE;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,iCAAiC;AACnE","sourcesContent":["/* Adjustments for section spacing */\n#home,\n#gallery {\n  padding-top: 100px; /* Ensure space from the navbar */\n  padding-bottom: 100px;\n}\n\n#contact {\n  padding-top: 130px;\n  margin-bottom: 130px;\n}\n\n#about {\n  padding-top: 100px;\n  margin-bottom: 100px;\n}\n#menu {\n  margin-top: 200px;\n  margin-bottom: 100px;\n  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, .8);\n}\n\n#gallery {\n  padding: 100px 0;\n  margin-bottom: 70px;\n}\n\n#gallery h1 {\n  color: #8B4513; /* Warm brown color */\n  margin-bottom: 20px;\n}\n\n.carousel-container {\n  max-width: 800px; /* Adjust the max width to your preference */\n  margin: 0 auto; /* Center the carousel */\n}\n\n.carousel-image {\n  height: 400px; /* Adjust the height to your preference */\n  object-fit: cover; /* Ensure the image covers the entire area */\n}\n\n.carousel-caption {\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 10px;\n  border-radius: 5px;\n}\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.content {\n  flex: 1;\n}\n\n.background-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.background-container img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n}\n\n.background-container img.active {\n  opacity: 1;\n}\n\n.background-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Darken the background images */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
